import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import { isAuthenticated, login } from 'utils/auth'
import { reverse } from 'routes'
import request from 'utils/request'

import { LOGIN_URL } from 'constants'
import { statusChanged } from 'components/RequestStatus/actions'

import Input from 'components/Input'
import Button from 'components/Button'
import RequestStatus from 'components/RequestStatus'

import './style.scss'


export class Login extends BaseComponent {
  constructor() {
    super()
    this.state = {
      buttonProps: {},
      formData: {
        email: '',
        password: ''
      },
      errors: {
        email: [],
        password: []
      }
    }
    this._bind('_onSubmit', '_onChange', '_renderInvalidToken')
  }

  componentWillMount() {
    if ( isAuthenticated() )
      this.context.router.history.replace('/')
  }

  componentDidMount() {
    document.title = 'Custodian | Iniciar Sesión'
  }

  _renderInvalidToken() {
    const locationState = this.props.location.state
    return !!locationState && locationState.status === 'ok' ? (
      <p className="Login__password-updated">¡Contraseña actualizada!</p>
    ) : null
  }

  // we need to use asyn-await here in order to test it :(
  // TODO: find a way that avoids using async-await
  async _onSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Iniciando sesión...')
    this.setState({
      buttonProps: { disabled: true }
    })

    await request(LOGIN_URL, {
      method: 'POST',
      body: { ...this.state.formData }
    })
    .then(({token, user}) => {
      // if request succeeds go to dashboard URI
      // we don't need to enabled button or change RequestStatus props here
      // TODO: save token and other required data to localStorage
      if( !user.is_staff ) {
        const error = new Error('Invalid user')
        error.response = {
          status: 'error',
          message: 'Tu usuario no tiene permisos'
        }
        throw error
      } else {
        login(token, user)
        this.context.router.history.replace('/')
      }
      this.props.updateRequestStatus('ok', 'Sesión iniciada...')
    })
    .catch(({response}) => {
      const errors = !!response.fields ? {...response.fields} : {}
      this.props.updateRequestStatus(response.status, response.message)
      this.setState({
        buttonProps: {},
        errors: {...errors}
      })
    })
  }

  _onChange(evt) {
    this.setState({
      formData: {
        ...this.state.formData,
        [evt.target.name]: evt.target.value
      }
    })
  }

  render () {
    return (
      <div id="Login">
        <div>
          {this._renderInvalidToken()}
        </div>
        <div className="Login__section_title">
          <h5>Iniciar sesión</h5>
        </div>
        <form onSubmit={this._onSubmit} className="Login__form">
          <div className="Login__form__fields">
            <Input
              type="email"
              icon="person"
              tabIndex="1"
              name="email"
              size="big"
              required
              autoFocus
              value={this.state.formData.email}
              onChange={this._onChange}
              errors={this.state.errors.email}
              placeholder="Correo electrónico"
            />
            <Input
              type="password"
              name="password"
              icon="lock"
              size="big"
              required
              tabIndex="2"
              value={this.state.formData.password}
              onChange={this._onChange}
              errors={this.state.errors.password}
              placeholder="Contraseña"
            />
          </div>
          <div className="Login__form__indicator">
            <RequestStatus />
          </div>
          <div className="Login__form__actions row align-items-center">
            <div className="col">
              <Button
                type="submit"
                buttonType="primary"
                tabIndex="3"
                size="big"
                {...this.state.buttonProps}
              >
                ENTRAR
              </Button>
            </div>
            <div className="col Login__form__actions__forgot-password">
              <Link to={reverse('accounts:password_recovery')} tabIndex="4">¿Olvidaste tu contraseña?</Link>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(Login)

Login.contextTypes = {
  router: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js